import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7c6899e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-header" }, [
  /*#__PURE__*/_createTextVNode(" Suggested Products "),
  /*#__PURE__*/_createElementVNode("hr")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "body-showcase"
}
const _hoisted_4 = { class: "item-card-image" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "item-card-label" }
const _hoisted_7 = { class: "item-card-description" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "body-showcase body-placeholders-showcase"
}
const _hoisted_10 = { class: "secondary-button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_TransitionGroup, { name: "list" }, {
        default: _withCtx(() => [
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedItems, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "item-card",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("img", {
                        src: require(`@/assets/img/products/${item.alias}.png`),
                        alt: item.name
                      }, null, 8, _hoisted_5)
                    ]),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1),
                    _createElementVNode("div", _hoisted_7, [
                      _createTextVNode(" Min " + _toDisplayString(item.minQuantity) + " units ", 1),
                      _hoisted_8,
                      _createTextVNode(" Prices start from $" + _toDisplayString(item.minPrice) + " + GST ", 1)
                    ]),
                    _createVNode(_component_Button, {
                      onClick: ($event: any) => (_ctx.goToEdit(item.alias)),
                      label: "ADD TO CART"
                    }, null, 8, ["onClick"])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item) => {
                  return _createVNode(_component_Skeleton, {
                    key: item,
                    style: {"height":"387px","width":"235px","margin":"10px 30px","box-shadow":"4px 4px 9px #959595"}
                  })
                }), 64))
              ]))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_Button, {
          label: "CONTINUE TO CART",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'cart' }))),
          class: "secondary-button"
        })
      ])
    ])
  ]))
}